export const maxWidth = 1296;
export const padding = 24;
/// This is the width where the site switches between mobile and desktop layouts
export const mobileMaxWidth = 800;

export const effectiveMaxWidth = (): number => maxWidth - padding * 2;
export const effectiveMobileMaxWidth = (): number =>
  mobileMaxWidth - padding * 2;
